import { Modal } from '../../modal/js/global';

/**
 * Header portal component selector
 * @const {string}
 */
export const HEADER_PORTAL_SELECTOR = '[data-component="header-portal"]';

export default function _headerPortal() {
    /**
     * Main portal body selector
     * @const {string}
     */
    const HEADER_PORTAL_BODY_SELECTOR = '.header-portal__modal';

    /**
     * Open action selector
     * @const {string}
     */
    const HEADER_PORTAL_OPEN_ACTION_SELECTOR =
        '[data-click="header-portal-open"]';

    /**
     * Open action selector
     * @const {string}
     */
    const HEADER_PORTAL_TOGGLE_ACTION_SELECTOR =
        '[data-click="header-portal-toggle"]';

    /**
     * Close action selector
     * @const {string}
     */
    const HEADER_PORTAL_CLOSE_ACTION_SELECTOR =
        '[data-click="header-portal-close"]';

    /**
     * Header portal open/active class
     * @const {string}
     */
    const HEADER_PORTAL_ACTIVE_CLASS = 'header-portal-wrapper--active';

    /**
     * Create a new HeaderPortal
     * @param {HTMLElement} headerPortal - The wrapping HTML element of the headerPortal
     * @class
     */
    class HeaderPortal {
        constructor(headerPortalWrapper) {
            this.headerPortalWrapper = headerPortalWrapper;
            this.headerPortal = headerPortalWrapper.querySelector(
                HEADER_PORTAL_BODY_SELECTOR
            );

            // HeaderPortal isnt always a Modal so use it as a composite rather than as a parent
            this.modalHandler = new Modal(headerPortalWrapper);

            // Attach event handlers to open
            headerPortalWrapper
                .querySelectorAll(HEADER_PORTAL_OPEN_ACTION_SELECTOR)
                .forEach((element) => {
                    element.addEventListener('click', () => {
                        this.openPortal();
                    });
                });

            // Attach event handlers to open
            headerPortalWrapper
                .querySelectorAll(HEADER_PORTAL_TOGGLE_ACTION_SELECTOR)
                .forEach((element) => {
                    element.addEventListener('click', () => {
                        this.togglePortal();
                    });
                });

            // Attach event handlers to close
            headerPortalWrapper
                .querySelectorAll(HEADER_PORTAL_CLOSE_ACTION_SELECTOR)
                .forEach((element) => {
                    element.addEventListener('click', () => {
                        this.closePortal();
                    });
                });
        }

        /**
         * Open the portal and handles extras like setting up modal ally and focus.
         */
        openPortal() {
            if (!this.isOpen()) {
                // Add CSS class to activate styling
                this.headerPortalWrapper.classList.add(
                    HEADER_PORTAL_ACTIVE_CLASS
                );

                this._activateDropdown();
            }
        }

        /**
         * Helper function to activate the ally modal features + markup
         */
        _activateDropdown() {
            // Tag the toggle button as expanded
            this.headerPortalWrapper
                .querySelectorAll(HEADER_PORTAL_TOGGLE_ACTION_SELECTOR)
                .forEach((element) => {
                    element.setAttribute('aria-expanded', true);
                });

            function listener(event) {
                if (!this.headerPortalWrapper.contains(event.target)) {
                    this.closePortal();
                }
            }
            this.fadeInDocListener = listener.bind(this);

            document.addEventListener('click', this.fadeInDocListener);
        }

        /**
         * Function to open or close the portal depending on if open or not already
         */
        togglePortal() {
            if (this.isOpen()) {
                this.closePortal();
            } else {
                this.openPortal();
            }
        }

        /**
         * Closes the modal and deactivates any modal ally and media watch
         */
        closePortal() {
            if (this.isOpen()) {
                // Remove CSS class to deactivate styling
                this.headerPortalWrapper.classList.remove(
                    HEADER_PORTAL_ACTIVE_CLASS
                );

                // If the portal content was modal based disable the accessability features
                this._deactivateDropdown();
            }
        }

        /**
         * Helper function to deactivate the modal
         */
        _deactivateDropdown() {
            // Tag the toggle button as not expanded
            this.headerPortalWrapper
                .querySelectorAll(HEADER_PORTAL_TOGGLE_ACTION_SELECTOR)
                .forEach((element) => {
                    element.setAttribute('aria-expanded', false);
                });

            document.removeEventListener('click', this.fadeInDocListener);
            this.fadeInDocListener = undefined;
        }

        /**
         * Function to check if the portal is currently open
         */
        isOpen() {
            return this.headerPortalWrapper.matches(
                `.${HEADER_PORTAL_ACTIVE_CLASS}`
            );
        }
    }

    // Find all components (should only be one) and created handler objects
    const headerPortal = document.querySelectorAll(HEADER_PORTAL_SELECTOR);
    headerPortal.forEach((item) => {
        // Create a new item to modify
        const DOMItem = item;

        // Attach the class instance to our DOMItem
        if (!DOMItem.headerPortal) {
            DOMItem.headerPortal = new HeaderPortal(item);
        }
    });
}

_headerPortal();
